import { render, staticRenderFns } from "./Transition-Layer.vue?vue&type=template&id=236c1a6e&scoped=true"
import script from "./Transition-Layer.vue?vue&type=script&lang=js"
export * from "./Transition-Layer.vue?vue&type=script&lang=js"
import style0 from "./Transition-Layer.vue?vue&type=style&index=0&id=236c1a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c1a6e",
  null
  
)

export default component.exports